import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

import BaseControllerExams from '../controllers/BaseControllerExams';

interface File {
  body?: {
    uri: string;
  }
}

class ReportService {
  owner: BaseControllerExams;

  patientId: string | number;

  nrSequencia: string | number;

  endpointLista: string;

  parametrosLista: Record<string, Value>;

  constructor(owner: BaseControllerExams) {
    this.owner = owner;
    this.patientId = owner.context.get('patientId') as string | number;

    if (!this.patientId) {
      this.patientId = owner.historyService.getCurrentRouteParams()['nrSeqBeneficiario'] as string | number;
    }
  }

  openInNewWindow(url: string): void {
    const win = window.open(url, '_blank');
    if(win){
      win.focus();
    }
  }

  async gerarRelatorio(parametrosRelatorio: Record<string, Value>): Promise<string> {
    const body = {
      parameters: parametrosRelatorio,
    };

    const requestParams = { patientId: this.patientId };

    return HttpService.post(APPLICATION_ENDPOINTS.POST_REPORT_CONTENT, requestParams, { body })
      .then<string>(response => {
      const file = response as File;
      return resolvePath(`${APPLICATION_ENDPOINTS.GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri: file.body?.uri })
    })
  }
}

export default ReportService;
